import { QuestionRowModel } from 'survey-core';
import { SurveyPage as ReactSurveyPage } from 'survey-react-ui';
import { Fragment } from 'react';

import { SurveyRow } from '../SurveyRow/SurveyRow';
import { Content } from '../../Content';
import { Typography } from '../../Typography';

export class SurveyPage extends ReactSurveyPage {
  protected createRow(row: QuestionRowModel, css: any): JSX.Element {
    return (
      <SurveyRow
        key={row.id}
        row={row}
        survey={this.survey}
        creator={this.creator}
        css={css}
      />
    );
  }

  protected renderTitle(): JSX.Element {
    if (this.page.hasTitle) {
      return <Typography variant="h2">{this.page.title}</Typography>;
    }
    return null;
  }

  protected renderDescription(): JSX.Element | null {
    if (this.page.hasDescription) {
      return <Typography>{this.page.description}</Typography>;
    }
    return null;
  }

  protected renderElement(): JSX.Element {
    var title = this.renderTitle();
    var description = this.renderDescription();
    var rows = this.renderRows(this.panelBase.cssClasses);

    return (
      <Fragment>
        <Content.Subheader>
          {title}
          {description}
        </Content.Subheader>
        <Content.Fixed>{rows}</Content.Fixed>
      </Fragment>
    );
  }
}
